import { isEmpty } from 'lodash'
import { dateToMysql } from '@/helpers/dates'

const getTitleDates = agenda => {
  const dateStart = agenda.date_start
  const dateEnd = agenda.date_end

  if (isEmpty(dateStart)) {
    return dateEnd
  }

  if (isEmpty(dateEnd)) {
    return dateStart
  }

  return dateStart + ' a ' + dateEnd
}

const formatDates = agenda => {
  const date = []

  if (!isEmpty(agenda.date_start)) {
    date.push(dateToMysql(agenda.date_start))
  }

  if (!isEmpty(agenda.date_end)) {
    date.push(dateToMysql(agenda.date_end))
  }

  return date
}

export default (searchedBy, filters, agenda, level) => {
  if (!isEmpty(level)) {
    searchedBy.push(level.label)
  }
  const dates = formatDates(agenda)
  if (!isEmpty(dates)) {
    filters['schedules']['date'] = dates
    searchedBy.push(getTitleDates(agenda))
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/filters/filterBySchedulesLevel.js